import { FC } from 'react';
import { useFormContext } from 'react-hook-form';

import { Categories } from '../../../components/FormFields/Categories/Categories';
import { DateRange } from '../../../components/FormFields/DateRange';
import { RidersFilter } from '../../../components/FormFields/RidersFilter/RidersFilter';
import { StatusFilter } from '../../../components/FormFields/StatusFilter/StatusFilter';
import { Tags } from '../../../components/FormFields/Tags/Tags';

import { FilterContainer, FilterSelectGrid, FormWrapper } from './CustomReportForm.styles';
import { CustomReportHeader } from './CustomReportHeader';
import { FormPreferenceOptions } from './FormPreferenceOptions';
import { GroupByToggle } from './GroupByToggle';

export interface CustomReportFormProps {
  isDeleting: boolean;
  handleSubmit: (data) => void;
  handleDelete: (uuid) => void;
}

export const CustomReportForm: FC<CustomReportFormProps> = ({ isDeleting, handleSubmit, handleDelete }) => {
  const methods = useFormContext();

  return (
    <form id="custom-report-form" onSubmit={methods.handleSubmit(handleSubmit)}>
      <FormWrapper>
        <input type="hidden" {...methods.register('uuid')} />
        <CustomReportHeader isDeleting={isDeleting} handleOnDelete={handleDelete} />
        <FilterSelectGrid>
          <DateRange />
          <RidersFilter customReport={true} />
          <Categories />
          <Tags />
        </FilterSelectGrid>
        <FilterContainer>
          <StatusFilter />
        </FilterContainer>
        <GroupByToggle />
        <FormPreferenceOptions />
      </FormWrapper>
    </form>
  );
};
